import { render, staticRenderFns } from "./PublicRoadAccess.vue?vue&type=template&id=204c512b&"
import script from "./PublicRoadAccess.vue?vue&type=script&lang=js&"
export * from "./PublicRoadAccess.vue?vue&type=script&lang=js&"
import style0 from "./PublicRoadAccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports